/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
import { ISbStoryData } from '@storyblok/react/rsc'
import { atom } from 'jotai'

/** Atom for the current story. */
export const storyAtom = atom<ISbStoryData | null>(null)
